import React from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  StepText?: string;
  OfText?: string;
  ActiveStep?: number;
  TotalSteps?: number;
}

const StepIndicator = ({ StepText, OfText, ActiveStep, TotalSteps }: Props) => {
  const history = useHistory();
  return (
    <div className="u-marginBxxsm ">
      <div className="step-wizard">
        <div className="step-wizard-container u-center u-alignVcenter">
          <p className="u-textCenter">
            {StepText} <span className="u-textWeightBold">{ActiveStep}</span>{' '}
            {OfText} <span className="u-textWeightBold">{TotalSteps}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
